// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.Collection = M.Collection || {};
M.Collection.Sample = M.Collection.Sample || {};

/**
 * @class ColorChoiceList
 *
 * The collection of all user ColorChoice models
 */
M.Collection.Sample.ColorChoiceList = Backbone.Collection.extend({
  model: M.Model.Sample.ColorChoice,

  initialize: function() {
    // this value is used to ensure that new user defined colors always have
    // a unique name/id if an element is removed from the list
    this.currentIndex = 1;
  }

});